import { FC } from "react";

import { Text } from "components/text";
import LoadingSpinner from "./LoadingSpinner";

interface OverlayLoadingSpinnerProps {
  isLoading?: boolean;
  textTop?: string;
}

const ModalOverlayLoadingSpinner: FC<OverlayLoadingSpinnerProps> = ({
  isLoading,
  textTop,
}) => {
  return isLoading ? (
    <div
      data-testid="loading-spinner"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 1)",
        zIndex: 9999,
        userSelect: "none",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {textTop && (
          <Text variant="title" className="mt-5">
            {textTop}
          </Text>
        )}
        <LoadingSpinner />
      </div>
    </div>
  ) : null;
};

export default ModalOverlayLoadingSpinner;
